import template from './tsz-company-actions.html';
import './tsz-company-actions.styl';

function controller($scope, $state, $mdDialog, $tszToast, CompanyService) {

  'ngInject';

  this.delete = (ev) => {
    CompanyService.deleteAction(this.company, ev, () => {
      $scope.$emit('company_deleted', this.company.id);
    });
  };

  this.edit = () => {
    $state.go('admin_company', { id: this.company.id, name: this.company.name });
  };

}

export default {
  template,
  bindings: {
    company: '<',
  },
  controller,
};



// WEBPACK FOOTER //
// ./src/components/tsz-company-actions/tsz-company-actions.js